import React, {useEffect, useRef, useState} from 'react';
import {message,} from "antd";
import CandidateSearchModal from "../CandidateSearchModal";
import useApi from "../../../../../Hooks/Api";
import {useHistory, useParams} from "react-router-dom";
import EndVacancyModal from "../EndVacancyModal";
import moment from "moment";
import {FaCalendarAlt, FaRegThumbsDown, FaRegThumbsUp, FaSadCry, FaSmile} from "react-icons/all";
import {FaUsers} from "react-icons/fa";
import {Images} from "../../../../../Helpers/Images";


const VacancyEndFormComponent = ({enterpriseId, user}) => {
    const api = useApi();
    const [candidatesModal, setCandidatesModal] = useState(false)
    const paginate = useRef({
        page: 1,
    });
    const [loading, setLoading] = useState(true);
    const [showCards, setShowCards] = useState(null);
    const [step, setStep] = useState(0);

    const checkVacancies = (data) => {
        for (let i = 0; i < data.length; i++) {
            if(data[i].summary.approved === 0 && (data[i].summary.interview || data[i].summary.pending || data[i].summary.rejected || data[i].summary.selected)) {
                if((moment().diff(moment(data[i].closed_at), 'day') <= 15) && (data[i].vacancy_filled_external === null && data[i].vacancy_filled_internal === null)) {
                    setStep(0);
                    setShowCards(data[i]);
                    break;
                }
            }
        }
    };

    const getVacancies = async () => {
        paginate.current.page = 1;
        api.get(`sine/company_opportunities/${enterpriseId}?page=${paginate.current.page}&limit=20&closed=true`,(res) => {
            checkVacancies(res.opportunities);
        },(e) => {
            console.log(e);
        });
    };

    const handleEndVacancy = async (data) => {
        if(data.vacancy_filled_external || data.vacancy_not_filled) {
            message.success("Agradecemos pela contribuição!")
            setCandidatesModal(false);
            setShowCards(null);
        }
        setLoading(true);
        api.post(`sine/user/${user.user_id}/results-opportunity/${showCards.id}`, data,(res) => {
            setLoading(false);
        },(e) => {
            setLoading(false);
            setShowCards(false);
        });
    };

    const showFeedbackModal = (data) => {
        handleEndVacancy(data);
        if((showCards.summary.interview > 0 || showCards.summary.pending > 0 || showCards.summary.rejected > 0 || showCards.summary.selected > 0)) {
            if(showCards.summary?.approved === 0) {
                setCandidatesModal(true);
            } else {
                message.success("Agradecemos pela contribuição!")
                setCandidatesModal(false);
                setShowCards(null);
            }
        } else {
            message.success("Agradecemos pela contribuição!")
            setCandidatesModal(false);
            setShowCards(null);
        }
    }


    useEffect(() => {
        window.scrollToElement('body');
        if(enterpriseId) {
            getVacancies()
        }
    }, [enterpriseId]);


    return (
        <>
            {showCards ?
                <div className={'fade-in'} style={{backgroundColor: 'white', transition: '200ms',  marginBottom: 20, borderRadius: 5, boxShadow: 'rgb(0 0 0 / 8%) 0px 2px 9px 7px'}}>
                    <div className={'fade-in'} style={{padding: 10, background: 'rgb(199 229 251)', borderRadius: 5, color: '#2d8cd0', borderBottomRightRadius: 0, borderBottomLeftRadius: 0, fontSize: 14}}>
                        <span>E aí, conseguiu preencher sua vaga? </span>
                    </div>
                    <div style={{ paddingTop: 10, paddingBottom: 10, transition: '200ms', textAlign: 'center', display: step === 0? 'block' : 'none'}}>
                        <div>
                            <span style={{fontSize: '18px', fontWeight: 'bold'}}>{showCards.occupation_title? showCards.occupation_title : showCards.occupation_name}  </span> <br/>
                            <span style={{fontSize: 13, color: "#858585"}}> {showCards.occupation_title? (showCards.occupation_name + " / " + showCards.job_type[0]) : showCards.job_type[0] }</span> <br/>
                            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                <FaUsers style={{fontSize: 13, color: "#9e9e9e", marginRight: 3}}/>
                                <span style={{fontSize: 13, color: "#9e9e9e"}}> {showCards.summary.approved + showCards.summary.interview + showCards.summary.selected + showCards.summary.rejected + showCards.summary.pending} inscritos</span>
                            </div>
                            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                <FaCalendarAlt style={{fontSize: 13, color: "#9e9e9e", marginRight: 3}}/>
                                <span style={{fontSize: 13, color: "#9e9e9e"}}> Encerrada em {moment(showCards.closed_at).format('DD/MM')}</span>
                            </div>
                        </div>
                    </div>

                     <div className={'fade-in'} style={{
                        display: step === 0? "flex" : 'none',
                        justifyContent: "center", transition: '200ms',
                    }}>
                        <div onClick={() => {
                            setStep(1);
                        }}   className={'cardButton cardButtonGreen cardButtonGreenIcon'} style={{padding: 5,   borderRadius: 5, borderTopLeftRadius: 0, borderBottomRightRadius: 0, backgroundColor: 'white', flex: 1,  display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <FaSmile style={{fontSize: 16, marginRight: 3}}/>
                            <div>
                                <span> Consegui preencher </span>
                            </div>
                        </div>
                        <div onClick={() => handleEndVacancy({vacancy_not_filled: true, vacancy_filled_external: false, vacancy_filled_internal: false})}  className={'cardButton cardButtonRed cardButtonRedIcon'} style={{padding: 5,  borderRadius: 5, borderTopRightRadius: 0, borderBottomLeftRadius: 0, backgroundColor: 'white', flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <FaSadCry style={{fontSize: 16, marginRight: 3}}/>
                            <div>
                                <span> Não consegui </span>
                            </div>
                        </div>

                    </div>
                    <div className={'fade-in'} style={{display: step === 1? 'block' : 'none', transition: '200ms', textAlign: 'center'}}>
                        <img src={Images.rocket2} style={{marginTop: 10, marginBottom: 10}}/>

                        <div style={{paddingRight: 10, paddingLeft: 10, marginBottom: 10}}>
                            <span style={{fontWeight: 'bold'}}>Foi através de nossa plataforma? <br/> fala pra gente, isso nos ajuda muito! </span>
                        </div>

                        <div style={{
                            display: "flex",
                            justifyContent: "center"
                        }}>
                            <div onClick={() => showFeedbackModal({vacancy_filled_internal: true, vacancy_filled_external: false, vacancy_not_filled: false})}   className={'cardButton cardButtonGreen cardButtonGreenIcon'} style={{padding: 5, paddingRight: 10, paddingLeft: 10,  borderRadius: 5, borderTopLeftRadius: 0, borderBottomRightRadius: 0, backgroundColor: 'white', flex: 1, minWidth: 200,  display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                <FaRegThumbsUp style={{fontSize: 15, marginRight: 5}}/>
                                <div>
                                    <span> Foi pela plataforma </span>
                                </div>
                            </div>
                            <div onClick={() => handleEndVacancy({vacancy_filled_internal: false, vacancy_filled_external: true, vacancy_not_filled: false})}  className={'cardButton cardButtonRed cardButtonRedIcon'} style={{padding: 5,  paddingRight: 10, paddingLeft: 10,  borderRadius: 5, borderTopRightRadius: 0, borderBottomLeftRadius: 0, backgroundColor: 'white', flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                <FaRegThumbsDown style={{fontSize: 15, marginRight: 5}}/>
                                <div>
                                    <span> Não foi </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                :
                null
            }
            {candidatesModal && <CandidateSearchModal infoOnly={true} opportunity_id={showCards.id} handleEndVacancy={() => {
                message.success("Agradecemos pela contribuição!");
                setCandidatesModal(false);
                setShowCards(null);
            }} visible={candidatesModal} setVisible={() => {
                message.success("Agradecemos pela contribuição!");
                setCandidatesModal(false);
                setShowCards(false);
            }} enterprise={{id:enterpriseId}}/>}
        </>
    );
};

VacancyEndFormComponent.propTypes = {};

export default VacancyEndFormComponent;
